module.exports = __webpack_public_path__ + "img/horn_4.9ab781c1.png";